import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../../../../../pages/base-error";

@Component({
  selector: "generic-sfl-item",
  templateUrl: "./generic-sfl-item.component.html",
})
export class GenericSflItemComponent extends BaseError implements OnInit {

  @Input() public item: any;
  @Input() public prefix: string = "";
  @Output() public isReady = new EventEmitter();
  @Output() public updated = new EventEmitter();
  public opened: boolean = false;

  constructor(
    public translate: TranslateService,
    public toastr: ToastrService,
  ) {
    super(toastr);
  }

  public ngOnInit(): void {
    this.isReady.emit(true);
  }

  public toggle() {
    this.opened = !this.opened;
    this.updated.emit();
  }

  public ready() {
    this.isReady.emit(true);
  }

  public update() {
    this.updated.emit();
  }

}
